import {Component, OnInit} from '@angular/core';
import {Observable} from 'rxjs';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {ProleisObject, SupplierConnection, SupplierContactsService} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-create-connection',
  templateUrl: 'create-connection.component.html'
})
export class CreateConnectionComponent implements OnInit {
  connection: SupplierConnection;
  connectionTypes$: Observable<ProleisObject[] | undefined>;

  constructor(private bs: MatBottomSheetRef, private service: SupplierContactsService) {
    this.connection = {
      info: '',
      text: '',
      typeId: ''
    };
  }

  ngOnInit() {
    this.connectionTypes$ = this.service.getConnectionTypes();
  }

  save() {
    this.bs.dismiss(this.connection);
  }

  dismiss() {
    this.bs.dismiss(null);
  }

}
